/*
 * @Description:
 * @Date: 2023-08-23 17:09:55
 */

import Vue from 'vue';
import store from '@/store/index.js';
import router from '@/router/index';
import QualificationDetailVue from './detail.vue';
import { Message, MessageBox } from 'element-ui';
import { certification } from '@/api/ajax';

export const QualificationDetail = QualificationDetailVue;

const DOM_ID = 'qualification-detail-230823';
const setFixedDOMStyle = dom => {
  let zIndex = 99;
  try {
    document.querySelector('.v-modal') &&
      (zIndex = document.querySelector('.v-modal').style.zIndex);
  } catch (error) {
    console.log(error);
  }
  dom.style.position = 'fixed';
  dom.style.width = '100vw';
  dom.style.height = '100vh';
  dom.style.left = '0px';
  dom.style.top = '0px';
  dom.style.background = 'rgba(0,0,0,0.7)';
  dom.style.zIndex = +zIndex + 1;
};
export const createQualificationDetail = props => {
  return new Promise(resolve => {
    const Constructor = Vue.extend({
      ...QualificationDetailVue,
      store,
      router
    });
    if (document.querySelector(`#${DOM_ID}`)) {
      console.warn('请勿重复创建');
      // document.body.removeChild(document.querySelector(`#${DOM_ID}`));
      return;
    }
    const dom = document.createElement('div');
    const remove = () => {
      document.body.style.overflow = 'initial';
      document.body.removeChild(dom);
      window.removeEventListener('hashchange', remove);
    };
    dom.id = DOM_ID;
    setFixedDOMStyle(dom);
    const instance = new Constructor({
      propsData: { ...(props || {}) },
      methods: {
        _resolve: resolve,
        _close: () => {
          remove();
        }
      }
    });
    instance.$mount();
    dom.appendChild(instance.$el);
    window.addEventListener('hashchange', remove);

    document.body.style.overflow = 'hidden';
    document.body.appendChild(dom);
  });
};

export const passQualifications = (ids, otherParams = {}) => {
  if (!Array.isArray(ids)) {
    console.error('调用passQualifications，请传入数组');
    return;
  }
  if (ids.length === 0) {
    Message.error('请至少选择一条！');
    return;
  }
  return new Promise((resolve, reject) => {
    MessageBox({
      title: '提示',
      message:
        Array.isArray(ids) && ids.length > 1
          ? `是否确认通过${ids.length}条数据，请谨慎操作`
          : '是否确认通过，请谨慎操作',
      showClose: false,
      showCancelButton: true,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      beforeClose: async (action, instance, done) => {
        if (instance.confirmButtonLoading) return;
        try {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const {
              data: { data }
            } = await certification.projectPersonnelAudit({
              userList: ids,
              auditStatus: 2,
              ...(typeof otherParams === 'object' ? otherParams : {})
            });
            resolve({ ids, nextId: data });
          }
          done();
        } finally {
          instance.confirmButtonLoading = false;
          done();
          reject('certification audit fail');
        }
      }
    });
  });
};
export const rejectQualifications = (
  ids,
  otherParams = {},
  inputConfig = { min: 5, max: 150 }
) => {
  if (!Array.isArray(ids)) {
    console.error('调用rejectQualifications，请传入数组');
    return;
  }
  if (ids.length === 0) {
    Message.error('请至少选择一条！');
    return;
  }
  return new Promise((resolve, reject) => {
    MessageBox.prompt('', '审核不通过', {
      showClose: false,
      showCancelButton: true,
      closeOnClickModal: false,
      closeOnPressEscape: false,
      inputType: 'textarea',
      inputPlaceholder:
        inputConfig.min > 0
          ? `请填写审核不通过原因，最少${inputConfig.min}个字`
          : '请填写审核不通过原因',
      inputValidator: val => {
        if (inputConfig.min == 0) {
          return !val || val.length <= inputConfig.max;
        }
        return !(
          !val ||
          val.length > inputConfig.max ||
          val.length < inputConfig.min
        );
      },
      inputErrorMessage:
        inputConfig.min === 0
          ? `最多输入${inputConfig.max}个字`
          : `请输入${inputConfig.min}~${inputConfig.max}个字`,
      beforeClose: async (action, instance, done) => {
        if (instance.confirmButtonLoading) return;
        try {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const {
              data: { data }
            } = await certification.projectPersonnelAudit({
              userList: ids,
              auditStatus: 3,
              description: instance.inputValue,
              ...(typeof otherParams === 'object' ? otherParams : {})
            });
            resolve({ ids, nextId: data });
          }
          done();
        } finally {
          instance.confirmButtonLoading = false;
          done();
          reject('certification audit fail');
        }
      }
    });
  });
};
